import type { ComponentProps } from "react";
import { t } from "ttag";

import { UpdatePaymentMethodModal } from "@/features/billing/sections";
import { useBoolean } from "@/shared/hooks";
import { Button, Card, CardIcon, PenIcon } from "@/shared/ui";
import { PaymentMethodCard } from "./components";

export const PaymentMethod = ({
  ...props
}: ComponentProps<typeof Card.Root>) => {
  const {
    value: showUpdatePaymentMethodModal,
    setTrue: openUpdatePaymentMethodModal,
    setFalse: closeUpdatePaymentMethodModal,
  } = useBoolean(false);

  const UpdateButton = ({ ...props }: ComponentProps<typeof Button>) => (
    <Button
      onClick={openUpdatePaymentMethodModal}
      variant="tertiary"
      size="lg"
      {...props}
    >
      <PenIcon className="size-4" />
      {t`Update`}
    </Button>
  );

  return (
    <Card.Root color="secondary" {...props}>
      <Card.Header className="justify-between">
        <Card.Title icon={CardIcon}>{t`Payment method`}</Card.Title>

        <UpdateButton className="hidden border-0 p-0 sm:flex" />
      </Card.Header>

      <PaymentMethodCard />

      <UpdateButton className="border-0 p-0 sm:hidden" />

      <UpdatePaymentMethodModal
        show={showUpdatePaymentMethodModal}
        onClose={closeUpdatePaymentMethodModal}
      />
    </Card.Root>
  );
};
